// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.web.user.payment.product.RentalManagerPaymentProductType

export enum RentalManagerPaymentProductType {
  DEFAULT = 'DEFAULT',
  /**
   * @deprecated
   */
  DEFAULT_REDUCED = 'DEFAULT_REDUCED',
  /**
   * @deprecated
   */
  FLAT_FEE = 'FLAT_FEE',
  FREEMIUM_FREE = 'FREEMIUM_FREE',
  FREEMIUM_PAID = 'FREEMIUM_PAID',
  /**
   * @deprecated
   */
  LEAD_GUARANTEE = 'LEAD_GUARANTEE',
}

export const RentalManagerPaymentProductType_values = [
  RentalManagerPaymentProductType.DEFAULT,
  RentalManagerPaymentProductType.DEFAULT_REDUCED,
  RentalManagerPaymentProductType.FLAT_FEE,
  RentalManagerPaymentProductType.FREEMIUM_FREE,
  RentalManagerPaymentProductType.FREEMIUM_PAID,
  RentalManagerPaymentProductType.LEAD_GUARANTEE,
] as const;
